<script setup lang="ts">
import { ref, computed } from 'vue';
import { UserStore } from '@/store/UserStore';
import Button from 'primevue/button';
import Select from 'primevue/select';

const emits = defineEmits<{ selectedRole: [selectedRole: any] }>();

const userStore = UserStore();
const selectedRole = ref('');
const users = computed(() => userStore.selectUser);
</script>

<template>
  <div class="login-select-role">
    <Select scrollHeight="400px" v-model="selectedRole" :options="users" optionLabel="givenName" optionGroupChildren="members" optionGroupLabel="displayName" :placeholder="$t('empty.select_a_role')" class="role-selector">
      <template #option="slotProps">
        <div class="role-options">
          {{ slotProps.option.givenName + ' ' + slotProps.option.surname }}
        </div>
      </template>
    </Select>
    <div>
      <Button id="submit-user" class="vacv-btn ml-1" :label="$t('common.buttons.submit')" @click="emits('selectedRole', selectedRole)" :disabled="!selectedRole" />
    </div>
  </div>
</template>
